import { useEffect, useState } from "react";
import { normalizeHex } from "@/lib/theme/generateTheme";

export const THEME_PRESETS = [
  { key: "black", hex: "#111111" },
  { key: "navy", hex: "#1B2A4A" },
  { key: "blue", hex: "#1D5FD6" },
  { key: "green", hex: "#1F6B4A" },
  { key: "purple", hex: "#5B3E96" },
  { key: "burgundy", hex: "#7A1F35" },
  { key: "orange", hex: "#D9622B" },
  { key: "teal", hex: "#0F766E" },
];

export function ThemeControls({ value, onChange }) {
  const [hex, setHex] = useState(value);
  const [error, setError] = useState(null);
  useEffect(() => {
    setHex(value);
    setError(null);
  }, [value]);

  const onHex = (raw) => {
    setHex(raw);
    const n = normalizeHex(raw);
    setError(n ? null : "Use #RGB or #RRGGBB.");
    if (n) onChange(n);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-4 gap-2">
        {THEME_PRESETS.map((p) => (
          <button key={p.key} type="button" onClick={() => onChange(p.hex.toLowerCase())} data-testid={`profile-theme-preset-${p.key}`} aria-label={`${p.key} theme`} aria-pressed={value === p.hex.toLowerCase()} className={`flex min-h-[64px] flex-col items-center justify-center gap-1.5 rounded-md border-2 transition-colors ${value === p.hex.toLowerCase() ? "border-foreground" : "border-transparent hover:border-border"}`}>
            <span className="h-7 w-7 rounded-full ring-1 ring-black/10" style={{ background: p.hex }} />
            <span className="text-[11px] capitalize text-muted-foreground">{p.key}</span>
          </button>
        ))}
      </div>
      <div className="space-y-2">
        <label htmlFor="theme-hex" className="mw-eyebrow">Custom color</label>
        <div className="flex items-center gap-3">
          <input type="color" value={value} onChange={(e) => onChange(e.target.value.toLowerCase())} data-testid="profile-theme-color-input" aria-label="Pick a color" className="h-12 w-14 shrink-0 cursor-pointer rounded-md border border-input bg-card p-1" />
          <input id="theme-hex" value={hex} onChange={(e) => onHex(e.target.value.trim())} maxLength={7} spellCheck={false} data-testid="profile-theme-hex-input" aria-invalid={Boolean(error)} className={`mw-input font-mono uppercase ${error ? "border-destructive" : ""}`} />
        </div>
        {error && <p data-testid="profile-theme-hex-error" className="text-xs text-destructive">{error}</p>}
      </div>
    </div>
  );
}
